// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/wir-haben-unser-netzwerk-erweitert/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const wirHabenUnserNetzwerkErweitertDE: PageEntry = {
  id: "post.wir-haben-unser-netzwerk-erweitert",
  locale: "de",
  slug: "wir-haben-unser-netzwerk-erweitert",
  seo: {
    title: "Wir haben unser Netzwerk erweitert, Kunststoff-Netzwerk Franken e.V | Dietz GmbH",
    description: "Wir haben unser Netzwerk erweitert, Kunststoff-Netzwerk Franken e.V",
  },
  type: "post",
  h1: "Wir haben unser Netzwerk erweitert, Kunststoff-Netzwerk Franken e.V",
  blocks: [
    { kind: "heading", level: 2, text: "Wir haben unser Netzwerk erweitert, Kunststoff-Netzwerk Franken e.V" },
    { kind: "paragraph", text: "Aufgrund unserer vielen Fertigungsmöglichkeiten im Bereich Metall- und Kunststofftechnik sind wir dem Kunststoff-Netzwerk Franken beigetreten." },
    { kind: "paragraph", text: "Der enge Kontakt zwischen Verarbeitern, Werkzeugbauern und Zulieferern, sowie Dienstleistern lässt die Sichtweise des jeweils anderen, dessen Fragestellungen, aber auch dessen Möglichkeiten erkennen." },
    { kind: "paragraph", text: "Es finden sich mögliche Kooperationspartner schneller, was eine effizientere Lösung der jeweiligen Herausforderung ermöglicht." },
    { kind: "paragraph", text: "Innerhalb des Netzwerks findet ein regelmäßiger Austausch im Bereich Kunststoffverarbeitung statt, somit wird unser Fachwissen kontinuierlich gesteigert und persönliche Beziehungsnetzwerke geknüpft." },
    { kind: "paragraph", text: "Wir, die Dietz GmbH, beteiligen uns an diversen Arbeitskreisen rund um Kunststofftechnik, um das Wissen unserer Fachkräfte stetig weiterzuentwickeln. Problemlösungen können so mit Fachexperten erarbeitet werden." },
    { kind: "paragraph", text: "Wir freuen uns Teil des Netzwerks zu sein, welches für unsere Kunden einen gewissen Mehrwert bringt." }
  ],
};
